import { defineMessages } from 'react-intl';

// Main route
const accountScope = 't.page.account';

// Global scope
const globalScope = 't.global';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
  // Main route
  passwordManagement: {
    id: `${accountScope}.passwordManagement`,
    defaultMessage: 'Gestione password',
  },
  languageManagement: {
    id: `${accountScope}.languageManagement`,
    defaultMessage: 'Gestione lingua',
  },
  pageTitle: {
    id: `${accountScope}.pageTitle`,
    defaultMessage: 'Modifica password',
  },
  oldPassword: {
    id: `${accountScope}.oldPassword`,
    defaultMessage: 'Vecchia password',
  },
  newPassword: {
    id: `${accountScope}.newPassword`,
    defaultMessage: 'Nuova password',
  },
  repeatedNewPassword: {
    id: `${accountScope}.repeatedNewPassword`,
    defaultMessage: 'Ripeti nuova password',
  },
  changeLanguage: {
    id: `${accountScope}.changeLanguage`,
    defaultMessage: 'Modifica lingua',
  },
  italian: {
    id: `${accountScope}.italian`,
    defaultMessage: 'Italiano',
  },
  english: {
    id: `${accountScope}.english`,
    defaultMessage: 'Inglese',
  },
  userProfile: {
    id: `${accountScope}.userProfile`,
    defaultMessage: 'Profilo utente',
  },

  // Global
  abortLabelButton: {
    id: `${globalScope}.abort`,
    defaultMessage: 'Annulla',
  },
  confirmLabelButton: {
    id: `${globalScope}.confirm`,
    defaultMessage: 'Conferma',
  },
  saveLabelButton: {
    id: `${globalScope}.save`,
    defaultMessage: 'Salva',
  },
  language: {
    id: `${globalScope}.language`,
    defaultMessage: 'Lingua',
  },
  edit: {
    id: `${globalScope}.edit`,
    defaultMessage: 'Modifica',
  },

  // Errors
  invalidPassword1: {
    id: `${globalErrorsScope}.invalidPassword1`,
    defaultMessage: 'Password non valida',
  },
  invalidPassword2: {
    id: `${globalErrorsScope}.invalidPassword2`,
    defaultMessage: 'Password non valida',
  },
  invalidRepeatedPassword: {
    id: `${globalErrorsScope}.invalidRepeatedPassword`,
    defaultMessage: 'Le password non coincidono',
  },
  maxLength: {
    id: `${globalErrorsScope}.maxLength`,
    defaultMessage: 'Lunghezza massima ({number}) superata',
  },
  fieldRequested: {
    id: `${globalErrorsScope}.fieldRequested`,
    defaultMessage: 'Campo obbligatorio',
  },
  invalidDate: {
    id: `${globalErrorsScope}.invalidDate`,
    defaultMessage: 'Data non valida',
  },
  theSecondDateIsMinorThanFirst: {
    id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
    defaultMessage: 'Data di fine troppo piccola',
  },
  fillFirstDateToContinueValidation: {
    id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
    defaultMessage: "Data d'inizio mancante",
  },
  invalidEmail: {
    id: `${globalErrorsScope}.invalidEmail`,
    defaultMessage: 'Email non valida',
  },
});
